/**
 * Extracts a user-friendly error message from a Clerk error object.
 */
export function getClerkErrorMessage(
  e: unknown,
  defaultMessage = "Something went wrong. Please try again.",
): string {
  const err = e as Record<string, any>;
  return (
    err?.errors?.[0]?.longMessage || err?.errors?.[0]?.message || err?.message || defaultMessage
  );
}
